import React, { CSSProperties, FunctionComponent, ReactNode } from 'react';

import { Link as GatsbyLink } from 'gatsby-link';
import isRelativeUrl from 'is-relative-url';
import join from 'url-join';

export type LinkProps = {
  id?: string;
  href?: string;
  to?: string;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
  children: ReactNode;
};

const css = {
  textDecoration: 'none',
  '& a': {
    textDecoration: 'none',
  },
};

const Link: FunctionComponent<LinkProps> = (props) => {
  const { href, to, children, ...other } = props;

  if (to) {
    const link = join('/', to, '/');
    return (
      <GatsbyLink css={css} to={to === '/' ? to : link} {...other}>
        {children}
      </GatsbyLink>
    );
  }
  if (href) {
    const isRelative = isRelativeUrl(href);
    return (
      <a css={css} href={href} target={isRelative ? undefined : '_blank'} {...other}>
        {children}
      </a>
    );
  }

  return (
    <button css={css} {...other}>
      {children}
    </button>
  );
};

export default Link;
